import styled from "styled-components";

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: var(--light-1);
    border-radius: 8px;
    padding: 0 20px;
`;